import { useHttpClient } from "@/common/api/httpClient";
import type { StorageAreaResponse } from "@/storageAreas/api/models/storageAreaResponse";
import { storeToRefs } from "pinia";
import type { Unit } from "shared/common/domain/bulkUnits";
import { useLanguageStore } from "shared/translations/stores/languageStore";

export interface MoveRequest {
  fromStorageAreaId: string;
  toStorageAreaId: string;
  empty?: boolean;
  coil?: MoveCoil;
  logYardContents?: MoveLogYardContent[];
  bulkContents?: MoveBulkContent[];
}

export interface MoveCoil {
  coilId: string;
  position: number;
  level: number;
}

export interface MoveLogYardContent {
  productId: string;
  numberOfLogs: number;
  volume: number;
}

export interface MoveBulkContent {
  productId: string;
  ton: number;
}

export interface MoveResponse {
  fromStorageArea: StorageAreaResponse;
  toStorageArea: StorageAreaResponse;
}

export function useMoveApi() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: MoveRequest) {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl('move'), {
      method: 'POST',
      headers,
      body: JSON.stringify(action)
    });

    const text = translations.value.moves.actions.pickAndPlace;

    const response = await httpClient.action(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as MoveResponse;
        return {
          ok: true,
          move: json
        };
      },
    });

    return response;
  }
}
